/* eslint-disable class-methods-use-this */
import produce from 'immer';
import { ChartMetaFormField, ErrorField } from 'models/ui';
import BaseHandler, { ExecuteParams } from './interface';

export default class ErrorHandler implements BaseHandler {
  execute({ field, ruleId, ruleRegistry }: ExecuteParams): ChartMetaFormField {
    const rule = ruleRegistry.get(ruleId);

    return produce(field, (draft) => {
      if (rule.result) {
        const error = {
          message: rule.ruleInfo.message,
          field: rule.ruleInfo.formFieldId,
          priority: 0,
          id: rule.ruleInfo.id,
          type: rule.ruleInfo.validationActionType
        };
        draft.errors.push(error);
      } else {
        const newErrors = draft.errors.filter((item: ErrorField) => item.id !== rule.ruleInfo.id);
        draft.errors = newErrors.length !== draft.errors.length ? newErrors : draft.errors;
      }
    });
  }
}
